(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ciq-reveal"] && !Shopify.designMode) return;
  try {
    (() => {
    const reveal = (root = document) => {
      if (
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        !('IntersectionObserver' in window)
      ) {
        return;
      }

      const io = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            entry.target.classList.add('ciq-in');
            io.unobserve(entry.target);
          }
        },
        { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
      );

      for (const el of root.querySelectorAll('[data-ciq-reveal]:not(.ciq-pre)')) {
        el.classList.add('ciq-pre');
        io.observe(el);
      }
    };

    reveal();
    document.addEventListener('shopify:section:load', (event) => reveal(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
